// HolidayCheck.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const HolidayCheck = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    de: "https://www.holidaycheck.de/hi/hotel-condesa/3a2215b1-7025-3186-ac28-cd4e5611fcaf",
  };

  return (
    <>
      {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
      <button
        className="button-styles hover-text"
        onClick={() => setShowModal(true)}
      >
        <span className="tooltip-text fade">
          HolidayCheck
        </span>
        <i className="fa fa-star" />
      </button>
      {showModal && (
        <LanguageModal
          title="HolidayCheck"
          icon="fa fa-star"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default HolidayCheck;
